module.exports = __webpack_public_path__ + "static/media/infografia_galdisa_embarazo_en.c462ed48.jpg";